import { render } from "./HotelDetail.vue?vue&type=template&id=edc98390&scoped=true"
import script from "./HotelDetail.vue?vue&type=script&lang=js"
export * from "./HotelDetail.vue?vue&type=script&lang=js"

import "./HotelDetail.vue?vue&type=style&index=0&id=edc98390&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc98390"]])

export default __exports__